















import { i18n } from '../../i18n';
import { computed, defineComponent, onMounted, ref } from 'vue-demi';
import { FitForm, FitFormItem, FitButton } from '@tencent/wphk-ui';
import FormatInput from './components/format-input/index.vue';
import { FormatInputType } from './components/format-input/format-type';
import { useTcaptcha, TCaptchaScene } from '@tencent/wphk-components-tcaptcha';
import { useGoodsInfo } from './hooks/goods-info';
import { useExchange } from './hooks/exchange';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { CustomException } from '@tencent/ppd-base-libs';

/**
 * CDK兑换奖品
 */
export default defineComponent({
  name: 'CouponExchangeIndex',
  components: {
    FitForm,
    FitFormItem,
    FormatInput,
    FitButton,
  },
  setup() {
    document.title = i18n('兌換碼換領優惠券TITLE');
    const scene = ref(TCaptchaScene.prom);
    const cdkey = ref('');
    const isFocus = ref(false);
    const isValidSuccess = computed(() => !!cdkey.value);
    const { ticket, randstr, verifyTCaptcha } = useTcaptcha(TCaptchaScene.prom);
    const { goodsInfo, initGoodsInfo } = useGoodsInfo(cdkey);
    const { exchangeCDK } = useExchange(cdkey, ticket, goodsInfo);

    async function exchange() {
      try {
        // 先初始化兑换的奖品信息
        await initGoodsInfo(ticket.value, randstr.value);
        // 执行cdk兑换
        await exchangeCDK();
      } catch (err) {
        showBusinessError(err);
        new CustomException(err, 'exchangeCDKException');
      }
    };

    async function handleSubmit() {
      biClick('cdk-exchange.submit_btn_click|兑换按钮点击');
      if (isValidSuccess && await verifyTCaptcha()) {
        biClick('cdk-exchange.verify_succ|防水墙验证通过');
        exchange();
      }
    };

    onMounted(() => {
      biBrow('cdk-exchange.page_brow');
    });

    return {
      scene,
      FormatInputType,
      cdkey,
      isValidSuccess,
      handleSubmit,
      isFocus,
    };
  },
});
